import React, {Component} from 'react'
import CBaseComponent from '@/components/CBaseComponent'
import {savaScore} from "@/servers/storeManageApi";
import './index.scss'
import {Button,message,Checkbox} from "antd";
import {bindActionCreators, compose} from "redux";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {getInfo} from "../../../../servers/menuAPI";
import { getStorage} from "@/utils";
import {refreshMenu} from "../../../../redux/common/action";
import CTable from '@/components/CTable'
import { tableData } from './data'
import store from "../../../../redux";
import {gotonext} from "../../../../utils";
@CBaseComponent
class SystemScore extends Component{

  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onChangetext = this.onChangetext.bind(this)
  }


  state = {
    columns: tableData.tHead,
    dataSource: tableData.tBody,
    notes:'',
    detaildata:[]
  }

  onSubmit(){
    gotonext()
    this.props.history.push({
      pathname: '/informationDeclaration/addition/proposalCentral',
    });
  }

  computedData(data){
    const str = data.replaceAll('\n', '</br>')
    return <div dangerouslySetInnerHTML={this.createMarkup(str)}></div>;
  }

  createMarkup(str) {
    return {__html: str}
  }

  changeinput(e,index){
    e.persist()
    const d = this.state.data
    d.forEach((item,i)=>{
      if (index === i) {
        item.score = e.target.value
      }
    })
    this.setState({
      data:d
    })
  }

  onChange(data, index){
    const d = this.state.dataSource
    d.forEach((item,index1)=>{
      if (index1 === index) {
        item.checked = data
      }
    })
    this.setState({
      dataSource: d
    })
  }

  onChangetext(data){
    this.setState({
      notes:data
    })
  }

  onSelect(){
    const params = {
      annual:localStorage.getItem('year'),
      indid:'4.2',
      museumid:store.getState().libraryid,
    }
    getInfo(params).then(res=>{
      res.records.forEach(item=>{
        if (Number(item.score) === 1){
          item.checked = true
        } else {
          item.checked = false
        }
      })
      this.setState({
        dataSource:res.records,
        notes: res.extra.scoretips,
      })
      if (res.extra.noteslist) {
        this.setState({
          detaildata:res.extra.noteslist
        })
      }
    })
  }

  componentWillUnmount() {
    // 在组件卸载时取消订阅
    if (this.unsubscribe) this.unsubscribe();
  }

  componentDidMount(){
    this.onSelect()
    let currentState = store.getState();
    this.unsubscribe = store.subscribe(() => {
      let previousState = currentState;
      currentState = store.getState();
      if (previousState.libraryid !== currentState.libraryid) {
        this.onSelect()
        this.props.refreshMenu(true)
      }
      if (previousState.year !== currentState.year) {
        this.onSelect()
        this.props.refreshMenu(true)
      }
    })
  }

  render(){
    return (
        <div className='detail-container' id="top">
          <div className="import">
          <h3 style={{color:'red'}}>警示减分建议</h3>
          <CTable ref='historyRecordDeleteUserList' checked={false} loading={false} columns={this.state.columns} dataSource={this.state.dataSource}>
            <div
                slot='index'
                render={(text, record, index) => (
                    <div className='operate'>
                      {index+1}
                    </div>
                )} />
            <div
                slot='jf'
                render={(text, record, index) => (
                    <div className='operate'>
                      <Checkbox checked={record.checked}  onChange={(e)=>{this.onChange(e,index)}}>
                        建议减分
                      </Checkbox>
                    </div>
                )} />
          </CTable>
          </div>
          <div className="import">
            <h3 style={{color:'red'}}>建议警示减分理由</h3>
            <div style={{borderTop:'1px solid #bebebe',borderLeft:'1px solid #bebebe'}}>
              {this.state.detaildata.length>0?
                  this.state.detaildata.map((item,index)=>{
                    if (index === 0) {
                      return (<div style={{display:'flex',borderBottom:'1px solid #bebebe',height:'35px'}}>
                        {
                          item.map(item2=>{
                            return (
                                <div style={{flex:1,textAlign:'center',borderRight:'1px solid #bebebe',height:'35px',lineHeight:'35px'}}>{item2}</div>
                            )
                          })
                        }
                      </div>)
                    } else {
                      return (<div style={{display:'flex',borderBottom:'1px solid #bebebe'}}>
                        {
                          item.map((item3)=>{
                            return (<div style={{flex:1,textAlign:'center',borderRight:'1px solid #bebebe',height:'35px',lineHeight:'35px'}}>{decodeURIComponent(item3)}</div>)
                          })
                        }
                      </div>)
                    }
                  }):''
              }
            </div>
          </div>
          <div className='detail-submit' style={this.props.collapsed?{width:'calc(100vw - 260px)',left:'260px'}:{width:'calc(100vw - 5px)',left:'50px'}}>
          <Button type="primary" className='yl' onClick={this.onSubmit}>下一步</Button>
          </div>
        </div>
    )
  }
}
const mapStateToProps = (state) => {
  return {
    collapsed: state.collapsed,  // 侧边栏是否展开
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    refreshMenu: bindActionCreators(refreshMenu, dispatch),
  };
};

export default compose(withRouter, connect(mapStateToProps,mapDispatchToProps))(SystemScore);
